import { combineReducers } from "redux";
import data from "./data";
import auth from "./auth";
import yh from './yh';

export default combineReducers({
    data,
    auth,
    yh
});
